(function(){
  function ready(fn){
    if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',fn);}else{fn();}
  }

  function initReveal(){
    var cards=[].slice.call(document.querySelectorAll('.sb-reveal'));
    if(!cards.length){return;}
    cards.forEach(function(card,index){card.style.setProperty('--sb-reveal-delay',Math.min(index%10,9)*70+'ms');});
    if(!('IntersectionObserver' in window)){
      cards.forEach(function(card){card.classList.add('is-visible');});
      return;
    }
    var observer=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target);}
      });
    },{threshold:0.14,rootMargin:'0px 0px -40px 0px'});
    cards.forEach(function(card){observer.observe(card);});
  }

  function initProductGalleries(){
    document.querySelectorAll('[data-product-gallery]').forEach(function(gallery){
      var slides=[].slice.call(gallery.querySelectorAll('[data-product-slide]'));
      var thumbs=[].slice.call(gallery.querySelectorAll('[data-product-thumb]'));
      var current=gallery.querySelector('[data-product-current]');
      var prev=gallery.querySelector('[data-product-prev]');
      var next=gallery.querySelector('[data-product-next]');
      if(!slides.length){return;}
      var active=0;
      function show(index){
        active=(index+slides.length)%slides.length;
        slides.forEach(function(slide,i){slide.classList.toggle('is-active',i===active);});
        thumbs.forEach(function(thumb,i){
          thumb.classList.toggle('is-active',i===active);
          if(i===active){thumb.setAttribute('aria-current','true');}else{thumb.removeAttribute('aria-current');}
        });
        if(current){current.textContent=String(active+1);}
      }
      thumbs.forEach(function(thumb){
        thumb.addEventListener('click',function(){
          var nextIndex=parseInt(thumb.getAttribute('data-product-thumb'),10);
          show(isNaN(nextIndex)?0:nextIndex);
        });
      });
      if(prev){prev.addEventListener('click',function(){show(active-1);});}
      if(next){next.addEventListener('click',function(){show(active+1);});}
      show(0);
    });
  }

  function initQtyControls(){
    document.querySelectorAll('[data-qty-control]').forEach(function(control){
      var input=control.querySelector('input');
      var minus=control.querySelector('[data-qty-minus]');
      var plus=control.querySelector('[data-qty-plus]');
      if(!input){return;}
      function setQty(change){
        var value=parseInt(input.value,10);
        if(isNaN(value)){value=1;}
        value=Math.max(1,value+change);
        input.value=String(value);
        input.dispatchEvent(new Event('change',{bubbles:true}));
      }
      if(minus){minus.addEventListener('click',function(){setQty(-1);});}
      if(plus){plus.addEventListener('click',function(){setQty(1);});}
    });
  }

  function cleanText(value){return String(value||'').replace(/\s+/g,' ').trim();}

  function formValue(form,selector){
    var field=form.querySelector(selector);
    if(!field){return '';}
    if(field.tagName==='SELECT'&&field.options[field.selectedIndex]){return cleanText(field.options[field.selectedIndex].text);}
    return cleanText(field.value);
  }

  function whatsappUrl(phone,lines){
    var cleanPhone=String(phone||'').replace(/\D/g,'');
    return 'https://wa.me/'+cleanPhone+'?text='+encodeURIComponent(lines.filter(Boolean).join('\n'));
  }

  function isEmbeddedPreview(){
    try{return window.self!==window.top;}catch(error){return true;}
  }

  function escapeToExternalPage(url){
    if(isEmbeddedPreview()){
      var escapeLink=document.createElement('a');
      escapeLink.href=url;
      escapeLink.target='_top';
      escapeLink.rel='noopener noreferrer external';
      escapeLink.style.position='fixed';
      escapeLink.style.left='-9999px';
      document.body.appendChild(escapeLink);
      escapeLink.click();
      window.setTimeout(function(){
        if(escapeLink.parentNode){escapeLink.parentNode.removeChild(escapeLink);}
      },1000);
      return;
    }

    var opened=window.open(url,'_blank');
    if(opened){
      try{opened.opener=null;}catch(error){}
    }else{
      window.location.assign(url);
    }
  }

  function openWhatsApp(phone,lines){
    escapeToExternalPage(whatsappUrl(phone,lines));
  }

  function initWhatsAppLinks(){
    document.querySelectorAll('a[href*="wa.me"],a[href*="whatsapp.com"]').forEach(function(link){
      link.setAttribute('rel','noopener noreferrer external');
      link.setAttribute('target',isEmbeddedPreview()?'_top':'_blank');
    });
  }

  function initContactChannels(){
    var form=document.getElementById('StyleBeautyContactForm');
    if(!form){return;}
    var whatsappButton=form.querySelector('[data-whatsapp-submit]');
    if(!whatsappButton){return;}
    whatsappButton.addEventListener('click',function(){
      if(typeof form.reportValidity==='function'&&!form.reportValidity()){return;}
      var name=formValue(form,'[name="contact[name]"]');
      var email=formValue(form,'[name="contact[email]"]');
      var phone=formValue(form,'[name="contact[phone]"]');
      var inquiry=formValue(form,'[name="contact[Inquiry type]"]');
      var orderNumber=formValue(form,'[name="contact[Order number]"]');
      var message=formValue(form,'[name="contact[body]"]');
      openWhatsApp(whatsappButton.getAttribute('data-whatsapp-phone'),[
        'Hi StyleBeauty, I need assistance.',
        'Name: '+name,
        'Email: '+email,
        phone?'Phone: '+phone:'',
        inquiry?'Inquiry: '+inquiry:'',
        orderNumber?'Order number: '+orderNumber:'',
        'Message: '+message,
        'Page: '+window.location.href
      ]);
    });
  }

  function initProductWhatsApp(){
    document.querySelectorAll('.sb-product-whatsapp').forEach(function(link){
      var phone='919041866992';
      function productMessage(){
        var summary=link.closest('.sb-product-summary')||document;
        var titleNode=summary.querySelector('h1');
        var select=summary.querySelector('select[name="id"]');
        var qty=summary.querySelector('input[name="quantity"]');
        var priceNode=summary.querySelector('.sb-product-price-main');
        var variant='';
        if(select&&select.options[select.selectedIndex]){variant=cleanText(select.options[select.selectedIndex].text).replace(/—\s*Sold out/i,'').trim();}
        return [
          'Hi StyleBeauty, I would like to order this product.',
          'Product: '+cleanText(titleNode?titleNode.textContent:document.title),
          variant&&variant.toLowerCase()!=='default title'?'Option: '+variant:'',
          'Quantity: '+cleanText(qty?qty.value:'1'),
          priceNode?'Price shown: '+cleanText(priceNode.textContent):'',
          'Product link: '+window.location.href
        ];
      }
      link.setAttribute('href',whatsappUrl(phone,productMessage()));
      link.setAttribute('target',isEmbeddedPreview()?'_top':'_blank');
      link.addEventListener('click',function(event){event.preventDefault();openWhatsApp(phone,productMessage());});
    });
  }

  function initPreOrderProductRequest(){
    var form=document.getElementById('sb-whatsapp-request-form');
    if(!form){return;}

    var fileInput=document.getElementById('sb-product-image');
    var linkInput=document.getElementById('sb-product-link');
    var errorBox=document.getElementById('sb-request-error');
    var submitButton=form.querySelector('button[type="submit"]');
    var phone='919041866992';

    function showError(message){
      if(!errorBox){return;}
      errorBox.textContent=message;
      errorBox.style.display='block';
      if(typeof errorBox.scrollIntoView==='function'){
        errorBox.scrollIntoView({behavior:'smooth',block:'center'});
      }
    }

    function clearError(){
      if(!errorBox){return;}
      errorBox.textContent='';
      errorBox.style.display='none';
    }

    form.setAttribute('action','#stylebeauty-product-request');
    form.setAttribute('data-whatsapp-integrated','true');
    if(submitButton){
      submitButton.setAttribute('data-whatsapp-request-submit','true');
      submitButton.setAttribute('aria-label','Send product request on WhatsApp');
    }

    form.addEventListener('submit',function(event){
      event.preventDefault();
      event.stopImmediatePropagation();
      clearError();

      if(typeof form.reportValidity==='function'&&!form.reportValidity()){return;}

      var productName=formValue(form,'#sb-product-name');
      var brandName=formValue(form,'#sb-brand-name');
      var variantShade=formValue(form,'#sb-variant-shade');
      var productLink=formValue(form,'#sb-product-link');
      var contactDetail=formValue(form,'#sb-contact-detail');
      var selectedFile=fileInput&&fileInput.files&&fileInput.files[0];

      if(!productName||!brandName||!variantShade||!contactDetail){
        showError('Please complete all required product and contact details.');
        return;
      }

      if(!selectedFile&&!productLink){
        showError('Please upload a product image or paste a product link.');
        return;
      }

      openWhatsApp(phone,[
        'Hello StyleBeauty, I would like to request a product.',
        '',
        '*Product Name:* '+productName,
        '*Brand Name:* '+brandName,
        '*Variant / Shade:* '+variantShade,
        '*Product Link:* '+(productLink||'Not provided'),
        '*Phone / Email:* '+contactDetail,
        '*Product Image:* '+(selectedFile?selectedFile.name+' — I will attach it in this WhatsApp chat.':'Not uploaded'),
        '',
        'I understand that StyleBeauty must confirm availability, estimated delivery time, and final price.',
        'Request page: '+window.location.href
      ]);
    },true);
  }

  ready(function(){
    initReveal();
    initProductGalleries();
    initQtyControls();
    initWhatsAppLinks();
    initContactChannels();
    initProductWhatsApp();
    initPreOrderProductRequest();
  });
})();
